import { OP, STATUS } from "../../constant";


const INITIAL_STATE = {
    // -------- egent initial ------- //
    agentStaffListStatus: STATUS.DEFAULT,
    agentStaffListResult: null,
    agentStaffListErrormessage: '',

    addAgentStaffStatus: STATUS.DEFAULT,
    addAgentStaffResult: null,
    addAgentStaffErrorMessage: '',

    viewAgentStaffStatus: STATUS.DEFAULT,
    viewAgentStaffResult: null,
    viewAgentStaffErrorMessage: '',

    editAgentStaffStatus: STATUS.DEFAULT,
    editAgentStaffResult: null,
    editAgentStaffErrorMessage: '',

    activateAgentStaffStatus: STATUS.DEFAULT,
    activateAgentStaffResult: null,
    activateAgentStaffErrorMessage: '',

    deactivateAgentStaffStatus: STATUS.DEFAULT,
    deactivateAgentStaffResult: null,
    deactivateAgentStaffErrorMessage: '',

    approveAgentStaffStatus: STATUS.DEFAULT,
    approveAgentStaffResult: null,
    approveAgentStaffErrorMessage: '',

    rejectAgentStaffStatus: STATUS.DEFAULT,
    rejectAgentStaffResult: null,
    rejectAgentStaffErrorMessage: '',

    resetAgentPasswordStatus: STATUS.DEFAULT,
    resetAgentPasswordResult: null,
    resetAgentPasswordErrorMessage: '',

    unblockAgentStatus: STATUS.DEFAULT,
    unblockAgentResult: null,
    unblockAgentErrorMessage: ''
}

export default (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
        // *-------- > agentStaff list reducers
        case OP.AGENT_STAFF_LIST_LOADING:
            return {
                ...state,
                agentStaffListStatus: STATUS.LOADING
            }
        case OP.AGENT_STAFF_LIST_SUCCESS:
            return {
                ...state,
                agentStaffListStatus: STATUS.SUCCESS,
                agentStaffListResult: payload,
                agentStaffListErrorMessage: ''
            }
        case OP.AGENT_STAFF_LIST_FAILURE:
            return {
                ...state,
                agentStaffListStatus: STATUS.ERROR,
                agentStaffListResult: null,
                agentStaffListErrorMessage: payload
            }
        case OP.AGENT_STAFF_LIST_RESET:
            return {
                ...state,
                agentStaffListStatus: STATUS.DEFAULT,
                agentStaffListResult: null,
                agentStaffListErrorMessage: ''
            }

        // *-------- > add agentStaff reducers
        case OP.ADD_AGENT_STAFF_LOADING:
            return {
                ...state,
                addAgentStaffStatus: STATUS.LOADING
            }
        case OP.ADD_AGENT_STAFF_SUCCESS:
            return {
                ...state,
                addAgentStaffStatus: STATUS.SUCCESS,
                addAgentStaffResult: payload,
                addAgentStaffErrorMessage: ''
            }
        case OP.ADD_AGENT_STAFF_FAILURE:
            return {
                ...state,
                addAgentStaffStatus: STATUS.ERROR,
                addAgentStaffResult: null,
                addAgentStaffErrorMessage: payload
            }
        case OP.ADD_AGENT_STAFF_RESET:
            return {
                ...state,
                addAgentStaffStatus: STATUS.DEFAULT,
                addAgentStaffResult: null,
                addAgentStaffErrorMessage: ''
            }

        // *-------- > view agentStaff reducers
        case OP.VIEW_AGENT_STAFF_LOADING:
            return {
                ...state,
                viewAgentStaffStatus: STATUS.LOADING
            }
        case OP.VIEW_AGENT_STAFF_SUCCESS:
            return {
                ...state,
                viewAgentStaffStatus: STATUS.SUCCESS,
                viewAgentStaffResult: payload,
                viewAgentStaffErrorMessage: ''
            }
        case OP.VIEW_AGENT_STAFF_FAILURE:
            return {
                ...state,
                viewAgentStaffStatus: STATUS.ERROR,
                viewAgentStaffResult: null,
                viewAgentStaffErrorMessage: payload
            }
        case OP.VIEW_AGENT_STAFF_RESET:
            return {
                ...state,
                viewAgentStaffStatus: STATUS.DEFAULT,
                viewAgentStaffResult: null,
                viewAgentStaffErrorMessage: ''
            }

        // *-------- > edit agentStaff reducers
        case OP.EDIT_AGENT_STAFF_LOADING:
            return {
                ...state,
                editAgentStaffStatus: STATUS.LOADING
            }
        case OP.EDIT_AGENT_STAFF_SUCCESS:
            return {
                ...state,
                editAgentStaffStatus: STATUS.SUCCESS,
                editAgentStaffResult: payload,
                editAgentStaffErrorMessage: ''
            }
        case OP.EDIT_AGENT_STAFF_FAILURE:
            return {
                ...state,
                editAgentStaffStatus: STATUS.ERROR,
                editAgentStaffResult: null,
                editAgentStaffErrorMessage: payload
            }
        case OP.EDIT_AGENT_STAFF_RESET:
            return {
                ...state,
                editAgentStaffStatus: STATUS.DEFAULT,
                editAgentStaffResult: null,
                editAgentStaffErrorMessage: ''
            }

        // *-------- > activate agentStaff reducers
        case OP.ACTIVATE_AGENT_STAFF_LOADING:
            return {
                ...state,
                activateAgentStaffStatus: STATUS.LOADING
            }
        case OP.ACTIVATE_AGENT_STAFF_SUCCESS:
            return {
                ...state,
                activateAgentStaffStatus: STATUS.SUCCESS,
                activateAgentStaffResult: payload,
                activateAgentStaffErrorMessage: ''
            }
        case OP.ACTIVATE_AGENT_STAFF_FAILURE:
            return {
                ...state,
                activateAgentStaffStatus: STATUS.ERROR,
                activateAgentStaffResult: null,
                activateAgentStaffErrorMessage: payload
            }
        case OP.ACTIVATE_AGENT_STAFF_RESET:
            return {
                ...state,
                activateAgentStaffStatus: STATUS.DEFAULT,
                activateAgentStaffResult: null,
                activateAgentStaffErrorMessage: ''
            }

        // *-------- > deactivate agentStaff reducers
        case OP.DEACTIVATE_AGENT_STAFF_LOADING:
            return {
                ...state,
                deactivateAgentStaffStatus: STATUS.LOADING
            }
        case OP.DEACTIVATE_AGENT_STAFF_SUCCESS:
            return {
                ...state,
                deactivateAgentStaffStatus: STATUS.SUCCESS,
                deactivateAgentStaffResult: payload,
                deactivateAgentStaffErrorMessage: ''
            }
        case OP.DEACTIVATE_AGENT_STAFF_FAILURE:
            return {
                ...state,
                deactivateAgentStaffStatus: STATUS.ERROR,
                deactivateAgentStaffResult: null,
                deactivateAgentStaffErrorMessage: payload
            }
        case OP.DEACTIVATE_AGENT_STAFF_RESET:
            return {
                ...state,
                deactivateAgentStaffStatus: STATUS.DEFAULT,
                deactivateAgentStaffResult: null,
                deactivateAgentStaffErrorMessage: ''
            }

        // *-------- >approve agentStaff reducers
        case OP.APPROVE_AGENT_STAFF_LOADING:
            return {
                ...state,
                approveAgentStaffStatus: STATUS.LOADING
            }
        case OP.APPROVE_AGENT_STAFF_SUCCESS:
            return {
                ...state,
                approveAgentStaffStatus: STATUS.SUCCESS,
                approveAgentStaffResult: payload,
                approveAgentStaffErrorMessage: ''
            }
        case OP.APPROVE_AGENT_STAFF_FAILURE:
            return {
                ...state,
                approveAgentStaffStatus: STATUS.ERROR,
                approveAgentStaffResult: null,
                approveAgentStaffErrorMessage: payload
            }
        case OP.APPROVE_AGENT_STAFF_RESET:
            return {
                ...state,
                approveAgentStaffStatus: STATUS.DEFAULT,
                approveAgentStaffResult: null,
                approveAgentStaffErrorMessage: ''
            }

        // *-------- >reject agentStaff reducers
        case OP.REJECT_AGENT_STAFF_LOADING:
            return {
                ...state,
                rejectAgentStaffStatus: STATUS.LOADING
            }
        case OP.REJECT_AGENT_STAFF_SUCCESS:
            return {
                ...state,
                rejectAgentStaffStatus: STATUS.SUCCESS,
                rejectAgentStaffResult: payload,
                rejectAgentStaffErrorMessage: ''
            }
        case OP.REJECT_AGENT_STAFF_FAILURE:
            return {
                ...state,
                rejectAgentStaffStatus: STATUS.ERROR,
                rejectAgentStaffResult: null,
                rejectAgentStaffErrorMessage: payload
            }
        case OP.REJECT_AGENT_STAFF_RESET:
            return {
                ...state,
                rejectAgentStaffStatus: STATUS.DEFAULT,
                rejectAgentStaffResult: null,
                rejectAgentStaffErrorMessage: ''
            }

        // *-------- >reset agent password reducers
        case OP.RESET_AGENT_PASSWORD_LOADING:
            return {
                ...state,
                resetAgentPasswordStatus: STATUS.LOADING
            }
        case OP.RESET_AGENT_PASSWORD_SUCCESS:
            return {
                ...state,
                resetAgentPasswordStatus: STATUS.SUCCESS,
                resetAgentPasswordResult: payload,
                resetAgentPasswordErrorMessage: ''
            }
        case OP.RESET_AGENT_PASSWORD_FAILURE:
            return {
                ...state,
                resetAgentPasswordStatus: STATUS.ERROR,
                resetAgentPasswordResult: null,
                resetAgentPasswordErrorMessage: payload
            }
        case OP.RESET_AGENT_PASSWORD_RESET:
            return {
                ...state,
                resetAgentPasswordStatus: STATUS.DEFAULT,
                resetAgentPasswordResult: null,
                resetAgentPasswordErrorMessage: ''
            }

        // *-------- >unblock agent reducers
        case OP.UNBLOCK_AGENT_LOADING:
            return {
                ...state,
                unblockAgentStatus: STATUS.LOADING
            }
        case OP.UNBLOCK_AGENT_SUCCESS:
            return {
                ...state,
                unblockAgentStatus: STATUS.SUCCESS,
                unblockAgentResult: payload,
                unblockAgentErrorMessage: ''
            }
        case OP.UNBLOCK_AGENT_FAILURE:
            return {
                ...state,
                unblockAgentStatus: STATUS.ERROR,
                unblockAgentResult: null,
                unblockAgentErrorMessage: payload
            }
        case OP.UNBLOCK_AGENT_RESET:
            return {
                ...state,
                unblockAgentStatus: STATUS.DEFAULT,
                unblockAgentResult: null,
                unblockAgentErrorMessage: ''
            }


        default:
            return state

    }
}